import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useContext, Slot } from "@builder.io/qwik";
import { modalContextId } from "./modal-context.qwik.mjs";
const HModalTitle = component$((props) => {
  const context = useContext(modalContextId);
  const titleId = `${context.localId}-title`;
  return /* @__PURE__ */ jsx("h2", {
    id: titleId,
    ...props,
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HModalTitle
};
